import { format } from 'date-fns';

export const DATE_FORMAT_DASH = `yyyy-MM-dd`;

export const formatDateToState = <T extends Date | null | undefined>(
  date: T,
): T extends Date ? string : null =>
  //@ts-expect-error TS2322
  date ? format(date, DATE_FORMAT_DASH) : null;
